import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormArray, FormControl, Form, FormBuilder, Validators } from '@angular/forms';



import {apiUrl} from '../global';

import { ResponseApi } from '../response-api';
import { ValidateEmailService } from '../validate-email.service';
import { SharedService } from '../shared.service';

function validateEmail(c: FormControl) {
  let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

  return EMAIL_REGEXP.test(c.value) ? null : {
    validateEmail: {
      valid: false
    }
  };
}

@Component({
  selector: 'validate-email',
  templateUrl: 'validate-email.component.html',
  styleUrls: ['validate-email.component.css'],
})
export class ValidateEmailComponent implements OnInit {
  responseApis: ResponseApi[];
  error: any;
  backgroundColor: string;
  text: string;


  constructor(private router: Router, private validateService: ValidateEmailService, private route: ActivatedRoute, private sharedService: SharedService) {

    this.text = "";
  }

  setBackgroundColor(backgroundColor: string):void{
    this.sharedService.setBackgroundColor(backgroundColor);
  }

  loginUser(){
    let link = [this.route.params['_value'].url+'/login'];
    this.router.navigate(link);
  }

  getBackgroundColor(){
    return this.sharedService.getVal('backgroundColor');
  }

  getHash(hash: string): void {
    this.validateService
      .getHash(hash)
      .then(responseApi => {
        this.responseApis = responseApi;
        this.text = this.responseApis['msg'];
        console.log(this.responseApis);
        console.log(hash)
        console.log('__________________________')
        localStorage.setItem('hash', hash);
        this.router.navigate([this.route.params['_value'].url+'/questionnaire/'+'policy'+'/1'])
      })
      .catch(error => this.error = error);
  }

  ngOnInit(): void {
    this.backgroundColor = this.getBackgroundColor();
    this.getHash(this.route.params['_value'].hash);
  }
}



// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/validate-email/validate-email.component.ts